import _ from 'lodash'
export const currentYear = new Date().getFullYear().toString()

export const getYearList = () => {
  const years = []
  for (let i = 2022; i <= currentYear; i++) {
    years.unshift(i.toString())
  }
  return years
}

export const getMonthData = data => {
  if (!data) data = {}
  const monthData = [
    data.month1 || 0,
    data.month2 || 0,
    data.month3 || 0,
    data.month4 || 0,
    data.month5 || 0,
    data.month6 || 0,
    data.month7 || 0,
    data.month8 || 0,
    data.month9 || 0,
    data.month10 || 0,
    data.month11 || 0,
    data.month12 || 0
  ]
  return monthData
}



// WEBPACK FOOTER //
// ./src/views/databaseAnlysis/userDataBoard/utils.js